const schedule = {
  // HeroSection
  'schedule.hero.homeLink': 'Home',
  'schedule.hero.aboutLink': 'About the Academy',
  'schedule.hero.currentPage': 'Annual Schedule',
  'schedule.hero.title': 'Annual Schedule',
  'schedule.hero.titleEn': 'ANNUAL SCHEDULE',
  'schedule.hero.lead': 'Each course runs according to the annual schedule. Applications are accepted up to 14 days before the start date.',
  'schedule.hero.imgAlt': 'The schedule and a class in session',

  // Calendar
  'schedule.calendar.label': 'ANNUAL CALENDAR',
  'schedule.calendar.title': 'Annual Course Calendar',
  'schedule.calendar.titleEn': 'Annual Course Calendar',
  'schedule.calendar.description': 'Please check the opening month for each course below. Confirmed start dates will be announced on our News page.',
  'schedule.calendar.altTitle': 'When Does Each Course Run?',
  'schedule.calendar.altDescription': 'Each course runs seasonally throughout the year. Choose the intake that best fits your schedule.',
  'schedule.calendar.footerNote': '* Confirmed dates will be announced on our News page.',
  'schedule.calendar.yearEnd.subLabel': 'YEAR-END BREAK',
  'schedule.calendar.month.1': 'Jan',
  'schedule.calendar.month.2': 'Feb',
  'schedule.calendar.month.3': 'Mar',
  'schedule.calendar.month.4': 'Apr',
  'schedule.calendar.month.5': 'May',
  'schedule.calendar.month.6': 'Jun',
  'schedule.calendar.month.7': 'Jul',
  'schedule.calendar.month.8': 'Aug',
  'schedule.calendar.month.9': 'Sep',
  'schedule.calendar.month.10': 'Oct',
  'schedule.calendar.month.11': 'Nov',
  'schedule.calendar.month.12': 'Dec',
  'schedule.calendar.course.essential': 'Essential',
  'schedule.calendar.course.advanced': 'Advanced',
  'schedule.calendar.course.master': 'Master',
  'schedule.calendar.course.break': 'Break',
  'schedule.calendar.course.double': 'Master & Advanced',
  'schedule.calendar.desc.essential': 'An introductory course focusing intensively on foundational butler techniques and service protocols',
  'schedule.calendar.desc.advanced': 'An intermediate course to deepen specialist skills including wine service and event management',
  'schedule.calendar.desc.master': 'The most advanced course, covering management, crisis response, and international protocol',
  'schedule.calendar.desc.break': 'Reserved for taster sessions and corporate training',
  'schedule.calendar.desc.double': 'The final phase of the Master course coincides with the opening of the Advanced course',
  'schedule.calendar.yearEnd.label': 'Year-End Break',
  'schedule.calendar.yearEnd.courseLabel': 'Closed',
  'schedule.calendar.yearEnd.description': 'All courses are suspended over the year-end and New Year period. The Essential course opens from January.',

  // CourseFlow
  'schedule.duration.structure': 'COURSE STRUCTURE',
  'schedule.duration.flowTitle': 'Course Overview by Duration',
  'schedule.duration.flowDescription': 'All courses are held on weekends, with 6 hours of instruction per day (4 x 90-minute sessions). Designed so you can study without disrupting your career.',
  'schedule.duration.viewLink': 'View Course Details',

  // ApplicationDeadline section header
  'schedule.app.label': 'APPLICATION',
  'schedule.app.title': 'Deadlines & Capacity',
  'schedule.app.titleEn': 'Deadlines & Capacity',
  'schedule.app.description': 'Applications are accepted up to 14 days before each start date. Places are strictly limited, so enrolment closes as soon as the class is full.',
  'schedule.app.footerNote': '* If fewer than 3 participants have enrolled, the course may be postponed. In that event, the published admissions policy applies.',

  // BreakPeriod
  'schedule.break.title': 'Off-Season Programmes',
  'schedule.break.titleEn': 'Off-Season Programs',
  'schedule.break.description': 'In August and over the year-end period, regular courses are suspended. During these breaks we run taster sessions and corporate training. Please take advantage of these opportunities for professional development.',
  'schedule.break.seminar.title': 'Taster Session',
  'schedule.break.seminar.desc': 'A one-day introductory session to experience butler techniques firsthand—ideal for those considering our full courses.',
  'schedule.break.seminar.link': 'Learn more',
  'schedule.break.corporate.title': 'Corporate Training',
  'schedule.break.corporate.desc': 'Bespoke hospitality and business etiquette training for organisations. We tailor programmes to your industry.',
  'schedule.break.corporate.link': 'Learn more',

  // CTASection
  'schedule.cta.courses': 'View Courses',

  // CourseDuration
  'schedule.duration.label': 'COURSE DURATION',
  'schedule.duration.title': 'Course Days & Hours',
  'schedule.duration.titleEn': 'Course Duration at a Glance',
  'schedule.duration.col.days': 'Class Days',
  'schedule.duration.col.hours': 'Total Hours',
  'schedule.duration.col.weeks': 'Duration',
  'schedule.duration.col.schedule': 'Start Months',
  'schedule.duration.viewCourse': 'Course Details',
  'schedule.duration.0.name': 'Essential Course',
  'schedule.duration.0.days': '8 days',
  'schedule.duration.0.hours': '48 hours',
  'schedule.duration.0.weeks': 'approx. 1 month',
  'schedule.duration.0.schedule': 'July & January',
  'schedule.duration.1.name': 'Advanced Course',
  'schedule.duration.1.days': '12 days',
  'schedule.duration.1.hours': '72 hours',
  'schedule.duration.1.weeks': 'approx. 2 months',
  'schedule.duration.1.schedule': 'May–Jun & Nov–Dec',
  'schedule.duration.2.name': 'Master Course',
  'schedule.duration.2.days': '16 days',
  'schedule.duration.2.hours': '96 hours',
  'schedule.duration.2.weeks': 'approx. 3 months',
  'schedule.duration.2.schedule': 'Feb–Apr & Sep–Nov',

  // CommonInfo
  'schedule.info.label': 'COMMON INFO',
  'schedule.info.title': 'Key Information',
  'schedule.info.titleEn': 'Schedule & Policies',
  'schedule.info.0': 'All classes are held on weekends. Each day comprises 6 hours of intensive instruction (4 x 90-minute sessions).',
  'schedule.info.1': 'Small-group format with a maximum of 6 students. The minimum number to run a course is 3.',
  'schedule.info.2': 'The application deadline is 14 days before the start date. Enrolment closes once the class is full.',
  'schedule.info.3': 'Payment is by bank transfer in full. Instalment plans and credit cards are not accepted.',

  // FAQSection
  'schedule.faq.label': 'FAQ',
  'schedule.faq.title': 'Frequently Asked Questions',
  'schedule.faq.titleEn': 'Frequently Asked Questions',
  'schedule.faq.footer': 'For further enquiries, please use our contact form.',
  'schedule.faq.0.question': 'When does each course run?',
  'schedule.faq.0.answer': 'The Master course runs from February to April and September to November; the Advanced course from May to June and November to December; and the Essential course in July and January. August and the year-end period are break periods.',
  'schedule.faq.1.question': 'What is the application deadline?',
  'schedule.faq.1.answer': '14 days before the course start date. Enrolment closes as soon as all 6 places are filled.',
  'schedule.faq.2.question': 'Where can I find the specific dates?',
  'schedule.faq.2.answer': 'Confirmed dates will be announced on our News page. We can also share the latest schedule during a brochure request or individual consultation.',

  // CTASection
  'schedule.cta.label': 'APPLY NOW',
  'schedule.cta.title': 'Request a Brochure or Book a Consultation',
  'schedule.cta.body': 'Full details of the schedule are shared during a brochure request or individual consultation. We would be delighted to hear from you.',
  'schedule.cta.note': '* Online consultations are also available.',
  'schedule.cta.brochure': 'Request a Brochure (Free)',
  'schedule.cta.consultation': 'Book a Consultation',

  // RelatedPages
  'schedule.related.label': 'LEARN MORE',
  'schedule.related.title': 'Related Pages',
  'schedule.related.titleEn': 'Explore Further',
  'schedule.related.viewLink': 'Learn more',
  'schedule.related.0.title': 'Course Comparison',
  'schedule.related.0.desc': 'Compare our three courses at a glance',
  'schedule.related.1.title': 'Essential Course',
  'schedule.related.1.desc': 'The introductory programme, built from the ground up',
  'schedule.related.2.title': 'Advanced Course',
  'schedule.related.2.desc': 'The intermediate programme for deepening specialist skills',
  'schedule.related.3.title': 'Master Course',
  'schedule.related.3.desc': 'The advanced programme covering management and crisis response',
  'schedule.related.4.title': 'Admissions Overview',
  'schedule.related.4.desc': 'The enrolment process and entry requirements',

  // Last updated
  'schedule.lastUpdated': 'Last updated: 8 July 2026',
};

export default schedule;
